import { Controller } from "stimulus";

export default class extends Controller
{
    static targets = []

    TYPES = [];
    RELATIONS = [];
    AUTHORITIES = [];

    connect()
    {
    }

    handleEdit(event)
    {
        if (event.detail[0].success)
        {
            const editEvent = new CustomEvent("show-toast", { detail: "Contact successfully created!" });
            window.dispatchEvent(editEvent);

            setTimeout(() =>
            {
                let a = document.createElement("a");
                a.href = event.detail[0].extra;
                a.classList.add("hidden");
                event.target.appendChild(a);
                a.click();
            }, 500)
        }
        else
        {
            const errorEvent = new CustomEvent("show-toast", { detail: "An error occurred: " + event.detail[0].error })
            window.dispatchEvent(errorEvent);
        }
    }

}